import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthProvider";
/* Importing Components */
import { Button } from "../../ui";
/* Importing Stylesheet */
import styles from "./style.module.scss";
import { ChevronDown, Person } from "react-bootstrap-icons";

const DashboardHeader = (props) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const {
    userData,
    allowedModules,
    selectedProject,
    setSelectedProject,
    logout,
  } = useAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleProjectSelect = (project) => {
    setSelectedProject(project);
    setIsDropdownOpen(false);

    // Navigate to dashboard when project changes (only if not already on dashboard)
    const currentPath = window.location.pathname;
    if (currentPath !== "/dashboard") {
      navigate("/dashboard");
    }
  };

  return (
    <>
      <header className={styles.modernHeader}>
        <div className={styles.headerBlock}>
          <div className={styles.titleSection}>
            <h1 className={styles.pageTitle}>{props.pageTitle}</h1>
            {props.pageDescription && (
              <p className={styles.pageDescription}>{props.pageDescription}</p>
            )}
          </div>
          <div>
            {/* Enhanced Project Selector Dropdown */}
            <div className={styles.headerBtnContainer}>
              {props.pathName === "/dashboard/locations" ? (
                <>
                  {/* <Button label={"See All"} primary className={styles.seeAll} /> */}
                  <Button
                    label={"Add Location"}
                    // icon={<GeoAlt />}
                    onClick={() => navigate("addNewLocation")}
                  />
                </>
              ) : props.pathName === "/dashboard/subAdmin" ? (
                <Button
                  label={"Add Sub Admin"}
                  onClick={() => navigate("addSubAdmin")}
                  style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
                />
              ) : props.pathName === "/dashboard/webPromotions" ? (
                <Button
                  label={"Add Promotion"}
                  onClick={() => navigate("addWebPromotion")}
                  style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
                />
              ) : props.pathName === "/dashboard/communityCare" ? (
                <Button
                  label={"Add Post "}
                  onClick={() => navigate("addBlog")}
                  style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
                />
              ) : props.pathName === "/dashboard/banner" ? (
                <Button
                  label={"Add Banner "}
                  onClick={() => navigate("addBanner")}
                  style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
                />
              ) : props.pathName === "/dashboard/carousel" ? (
                <Button
                  label={"Add Carousel"}
                  onClick={() => navigate("/dashboard/carousel/add")}
                  style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
                />
              ) : props.pathName === "/dashboard/propane-popup" ? (
                <Button
                  label={"Add Popup"}
                  onClick={() => navigate("/dashboard/propane-popup/add")}
                  style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
                />
              ) : props.pathName === "/dashboard/propane-promotions" ? (
                <Button
                  label={"Add Promotion"}
                  onClick={() => navigate("/dashboard/propane-promotions/add")}
                  style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
                />
              ) : props.pathName === "/dashboard/gas-plus-locations" ? (
                <Button
                  label={"Add Location"}
                  onClick={() =>
                    navigate("/dashboard/add-new-gas-plus-location")
                  }
                  style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
                />
              ) : null}
            </div>
            {allowedModules && allowedModules.length > 1 && (
              <div className={styles.projectSelector} ref={dropdownRef}>
                <div className={styles.selectWrapper}>
                  <button
                    type="button"
                    className={styles.projectDropdown}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    aria-haspopup="listbox"
                    aria-expanded={isDropdownOpen}
                  >
                    <span className={styles.selectedProject}>
                      {selectedProject?.name || "Select Project"}
                    </span>
                    <ChevronDown
                      className={`${styles.dropdownIcon} ${
                        isDropdownOpen ? styles.rotated : ""
                      }`}
                      size={18}
                    />
                  </button>

                  {isDropdownOpen && (
                    <div className={styles.dropdownList}>
                      {allowedModules.map((project) => (
                        <button
                          key={project.id}
                          type="button"
                          className={`${styles.dropdownOption} ${
                            selectedProject?.id === project.id
                              ? styles.selected
                              : ""
                          }`}
                          onClick={() => handleProjectSelect(project)}
                        >
                          {project.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className={styles.profileContainer}>
              <button className={styles.profileButton}>
                <div className={styles.profileInfo}>
                  <div className={styles.profileAvatar}>
                    <Person size={20} />
                  </div>
                  <div className={styles.userName}>
                    <span className={styles.userNameText}>
                      {userData.firstName !== "" && userData.lastName !== ""
                        ? userData.firstName + " " + userData.lastName
                        : "User"}
                    </span>
                  </div>
                  <ChevronDown className={styles.profileChevron} size={14} />
                </div>
                <div className={styles.profileMenu}>
                  <ul>
                    <li onClick={logout}>Logout</li>
                  </ul>
                </div>
              </button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default DashboardHeader;
